import Module from '../lib/module';
import { Uploader } from '../lib/mountable-file-server.js';

export default class AsyncFileUpload extends Module {
  setup() {
    this.fileField = this.element.querySelector('input[type="file"]');
    this.hiddenField = this.element.querySelector('input[type="hidden"]');
    this.progress = this.element.querySelector('[data-role="upload-progress"]');
    this.successMessage = this.element.querySelector('[data-role="upload-success-message"]');
    this.imageGrid = document.querySelector(this.element.getAttribute('data-image-grid'));
    this.imagePreview = document.querySelector(this.element.getAttribute('data-image-preview'));

    this.bind();
  }

  bind() {
    this.on('change', 'input[type="file"]', (event) => {
      this.upload(event.target.files[0], {
        url: event.target.getAttribute('data-url'),
        type: event.target.getAttribute('data-type') || 'public',
      });
    });
  }

  unbind() {
    this.off('change', 'input[type="file"]');
  }

  upload(file, options) {
    (new Uploader()).uploadFile({
      file: file,
      url: options.url,
      type: options.type,
      onStart: this._onUploadStart.bind(this),
      onProgress: this._onUploadProgress.bind(this),
      onSuccess: this._onUploadSuccess.bind(this),
    });
  }

  updateProgress(value) {
    if (this.progress.tagName.toLowerCase() === 'progress') {
      this.progress.setAttribute('value', value);
    } else {
      const bar = this.progress.querySelector('[role="progressbar"]');
      bar.style.width = value + '%';
      bar.setAttribute('aria-valuenow', value);

      if (value >= 10) {
        bar.textContent = value + '%';
      } else {
        bar.textContent = '';
      }
    }
  }

  _onUploadStart(event) {
    this.updateProgress(0);
    this.progress.classList.remove('d-none');
    this.hiddenField.value = '';

    if (this.successMessage) {
      this.successMessage.classList.add('d-none');
    }
  }

  _onUploadProgress(progress) {
    const percentage = Math.min(99, parseInt((progress.loaded / progress.total) * 100, 10));
    this.updateProgress(percentage);
  }

  _onUploadSuccess(response) {
    this.updateProgress(100);
    this.hiddenField.value = response.fid;
    this.progress.classList.add('d-none');
    this.fileField.value = '';
    this.updateProgress(0);

    if (this.successMessage) {
      this.successMessage.classList.remove('d-none');
    }

    if (this.imageGrid) {
      this._updateImageGrid(response.fid);
    }

    if (this.imagePreview) {
      this._updateImagePreview(response.fid);
    }
  }

  _updateImageGrid(fid) {
    const template = this.imageGrid.querySelector('template').content.cloneNode(true);
    const image = template.querySelector('img');
    const field = template.querySelector('input');
    image.src = image.src.replace('IMAGE_FID', fid);
    field.value = fid;

    this.imageGrid.appendChild(template);
    this.hiddenField.value = '';
    this.imageGrid.dispatchEvent(new CustomEvent('updated'));
  }

  _updateImagePreview(fid) {
    const template = this.imagePreview.querySelector('template').content.cloneNode(true);
    const templateImage = template.querySelector('img');
    const imageSrc = templateImage.src.replace('IMAGE_FID', fid);
    const existingImage = this.imagePreview.querySelector('img');

    if (existingImage) {
      existingImage.src = imageSrc;
    } else {
      templateImage.src = imageSrc;
      this.imagePreview.appendChild(template);
    }
  }
}
